import React from "react";

export const Input = ({ fildName, placeholder, type, handleChange }) => {
  return (
    <input
      name={fildName}
      onChange={handleChange}
      placeholder={placeholder}
      type={type}
      className="border border-solid border-green-600 h-12 px-5 mb-5 rounded-lg outline-none focus:outline-none"
    />
  );
};
